export default function EmptyState({ icon: Icon, illustration, title, description, action, className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center py-12 px-4 ${className}`}>
      {illustration
        ? <div className="mb-3">{illustration}</div>
        : Icon && <Icon size={28} strokeWidth={1.5} className="text-ink-faint mb-3" />}
      <p className="text-card-title font-display text-ink">{title}</p>
      {description && <p className="text-small text-ink-muted mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
